import { squareMeterShort } from '../constants/symbols';
import { LOCATION } from './regions';

type ArrayOfObjects<Obj extends {}> = (Obj & { id: number })[];

type AvatarScheme = {
  url: string;
  width: number;
  height: number;
};

type FactoidTitleScheme = {
  text: string;
  isText?: boolean;
};

type FactoidScheme = {
  title: ArrayOfObjects<FactoidTitleScheme>;
  subtitle: string;
};

type PhotoScheme = {
  title: string;
  url: string;
};

export type OfficesScheme = {
  avatar: AvatarScheme;
  title: string;
  photos: ArrayOfObjects<PhotoScheme>;
  moreInfo: string;
  description: string[];
  disclaimer: string;
  factoids: ArrayOfObjects<FactoidScheme>;
};

export type OfficesSchemeByLocation = Record<number, OfficesScheme>;

export const officesSchemeByLocation: OfficesSchemeByLocation = {
  [LOCATION.MOSCOW_AND_AREA.ID]: {
    avatar: {
      url: 'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/offers/lakes/logo.png',
      height: 32,
      width: 132,
    },
    title: 'Офисы',
    photos: [
      {
        id: 1,
        url: 'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/offers/lakes/photo_1.jpg',
        title: 'м. «Озёрная» 3 мин.',
      },
      {
        id: 2,
        url: 'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/offers/lakes/photo_2.jpg',
        title: '238 парковочных мест',
      },
      {
        id: 3,
        url: 'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/offers/lakes/photo_3.jpg',
        title: 'Офисные площади',
      },
      {
        id: 4,
        url: 'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/offers/lakes/photo_4.jpg',
        title: 'Торговые площади',
      },
    ],
    moreInfo: 'Подробнее на сайте lakes-office.ru',
    disclaimer: 'Ваше новое пространство для бизнеса в шаге от метро в одном из самых престижных округов Москвы.',
    description: [
      'LAKES — 18-ти этажный многофункциональный комплекс класса «B+» спроектирован архитектурным бюро Apex.',
      'В основу концепции заложена оригинальная форма фасада, стилистические решения, идеология многофункциональности и третьего места.',
    ],
    factoids: [
      { id: 1, title: [{ text: '69', id: 1 }], subtitle: 'офисов' },
      { id: 2, title: [{ text: `53 ${squareMeterShort}`, id: 1 }], subtitle: 'площадь от' },
      {
        id: 3,
        title: [
          { text: 'от', id: 1, isText: true },
          { text: '228', id: 2 },
          { text: 'тыс руб.', id: 3, isText: true },
        ],
        subtitle: `за ${squareMeterShort}`,
      },
    ],
  },
};
